import Loadable from 'app/components/Loadable';
import { lazy } from 'react';
import { authRoles } from '../../auth/authRoles';

const Terminal = Loadable(lazy(() => import('./Terminal')));

const TerminalRoutes = [
	{
		path: '/terminal',
		element: <Terminal />,
		auth: authRoles.admin,
	},
];

export default TerminalRoutes;
